// src/lib/theme.js
// Totonoeeテーマ管理
// 高級感 × ホワイト × ブラック
//   ライト = C.ハイブリッド（白ベース・主アクション黒・Indigoは機能アクセント）
//   ダーク = チャコール + ゴールド
// primary系トークンを新設し「主アクション(面)」と「accent(リンク/選択中)」を分離。

export const THEMES = {
  dark: {
    name: 'ダーク',
    // ── サーフェス（温かみのあるチャコール）──
    bg:        '#1a1a17',
    bgDeep:    '#141412',
    bgCard:    '#232320',
    bgInput:   '#1f1f1b',
    bgHover:   '#2a2a26',
    border:    '#34332e',
    borderLight: '#2a2a26',
    // ── テキスト ──
    textPrimary:   '#f5f4ef',
    textSecondary: '#c2c0b7',
    textMuted:     '#a8a69e',
    textWeak:      '#7c7a72',
    // ── 主アクション（ゴールド・面/ボタン）──
    primary:       '#b49157',
    primaryHover:  '#9c7c45',
    primaryText:   '#1a1a17',
    // ── アクセント（ゴールド明・リンク/選択中）──
    accent:        '#cdb079',
    accentHover:   '#b89a5f',
    accentText:    '#1a1a17',
    accentSub:     '#b49157',
    accentBg:      '#2e2920',
    accentBgLight: '#332d20',
    shadow:        'none',
    dot1: '#a8a69e', dot2: '#7dd3fc', dot3: '#fbbf24', dot4: '#c4b5fd', dot5: '#4ade80',
    badgeBg1: '#34332e', badgeBg2: '#1e3a5f', badgeBg3: '#451a03', badgeBg4: '#2e1065',
    badgeBg5: '#064e3b', badgeBg6: '#14532d', badgeBg7: '#0f2d4a', badgeBg8: '#0f4c81',
    badgeBg9: '#312e81', badgeBg10: '#1a0a2e', badgeBg11: '#1a2a1a', badgeBg12: '#1a2e1a',
    badgeBg13: '#1a3a2a', badgeBg14: '#1e2a4a', badgeBg15: '#1e1b0a',
    badgeTxt1: '#a8a69e', badgeTxt2: '#93c5fd', badgeTxt3: '#fcd34d', badgeTxt4: '#c4b5fd',
    badgeTxt5: '#6ee7b7', badgeTxt6: '#86efac', badgeTxt7: '#7dd3fc', badgeTxt8: '#93c5fd',
    badgeTxt9: '#a5b4fc', badgeTxt10: '#c084fc',
    colorAmber: '#f59e0b', colorGreen: '#4ade80', colorGreen2: '#34d399',
    colorPurple: '#a78bfa', colorBlue: '#7dd3fc', colorYellow: '#fbbf24',
    colorOrange: '#fb923c', colorRed: '#f87171', colorRed2: '#fca5a5',
    colorTeal: '#34d399', colorLight: '#a8a69e', colorPurple2: '#a855f7',
    colorBlue2: '#60a5fa', colorWhite2: '#f5f4ef', colorOrange2: '#fb923c',
    dangerBg: '#3a1715', dangerBg2: '#2a1412', dangerText: '#fca5a5', danger: '#ef4444',
    demoBg: '#fff7ed', demoBorder: '#f97316', demoText1: '#c2410c', demoText2: '#ea580c', demodot: '#92400e',
    violet: '#a78bfa', purpleBg: '#241b2e', purpleLight: '#e9d5ff', purpleMid: '#c084fc',
    expenseBg: '#1e3a29', expenseTxt: '#5bd68c', expenseBorder: '#2f5c42',
  },
  light: {
    name: 'ライト',
    // ── サーフェス（高級感のあるオフホワイト・カードを際立たせるため背景は一段濃く）──
    bg:        '#edece6',
    bgDeep:    '#ffffff',
    bgCard:    '#ffffff',
    bgInput:   '#f4f3ef',
    bgHover:   '#e6e4dc',
    border:    '#e2e0d8',
    borderLight: '#ece9e1',
    // ── テキスト（ニアブラック〜温かいグレー）──
    textPrimary:   '#111111',
    textSecondary: '#57564f',
    textMuted:     '#8a8980',
    textWeak:      '#a6a49c',
    // ── 主アクション（黒・面/ボタン）──
    primary:       '#111111',
    primaryHover:  '#2b2b28',
    primaryText:   '#ffffff',
    // ── アクセント（Indigo・リンク/選択中/アバター）──
    accent:        '#6366f1',
    accentHover:   '#4f46e5',
    accentText:    '#ffffff',
    accentSub:     '#8b5cf6',
    accentBg:      '#eef1fe',
    accentBgLight: '#f5f4ff',
    shadow:        '0 1px 2px rgba(17,17,17,0.04), 0 6px 18px -4px rgba(17,17,17,0.12)',
    dot1: '#8a8980', dot2: '#6366f1', dot3: '#b45309', dot4: '#7c3aed', dot5: '#15803d',
    badgeBg1: '#e8ecf2', badgeBg2: '#dbeafe', badgeBg3: '#fef3c7', badgeBg4: '#ede9fe',
    badgeBg5: '#d1fae5', badgeBg6: '#dcfce7', badgeBg7: '#e0f2fe', badgeBg8: '#bfdbfe',
    badgeBg9: '#e0e7ff', badgeBg10: '#f3e8ff', badgeBg11: '#d1fae5', badgeBg12: '#dcfce7',
    badgeBg13: '#d1fae5', badgeBg14: '#dbeafe', badgeBg15: '#fef9c3',
    badgeTxt1: '#57564f', badgeTxt2: '#1d4ed8', badgeTxt3: '#92400e', badgeTxt4: '#5b21b6',
    badgeTxt5: '#065f46', badgeTxt6: '#166534', badgeTxt7: '#075985', badgeTxt8: '#1e40af',
    badgeTxt9: '#3730a3', badgeTxt10: '#6d28d9',
    colorAmber: '#b45309', colorGreen: '#15803d', colorGreen2: '#16a34a',
    colorPurple: '#6d28d9', colorBlue: '#0284c7', colorYellow: '#a16207',
    colorOrange: '#c2410c', colorRed: '#b91c1c', colorRed2: '#991b1b',
    colorTeal: '#0f766e', colorLight: '#8a8980', colorPurple2: '#7c3aed',
    colorBlue2: '#0369a1', colorWhite2: '#ffffff', colorOrange2: '#ea580c',
    dangerBg: '#fcebeb', dangerBg2: '#f7c9c9', dangerText: '#991b1b', danger: '#dc2626',
    demoBg: '#fff7ed', demoBorder: '#f97316', demoText1: '#c2410c', demoText2: '#ea580c', demodot: '#92400e',
    violet: '#7c3aed', purpleBg: '#f5f3ff', purpleLight: '#1e1b4b', purpleMid: '#7c3aed',
    expenseBg: '#e7f7ee', expenseTxt: '#15803d', expenseBorder: '#c7e9d5',
  },
};

const THEME_KEY = 'totono_theme';
export function getSavedTheme() { return localStorage.getItem(THEME_KEY) || 'light'; }
export function saveTheme(key)  { localStorage.setItem(THEME_KEY, key); }
export function getTheme(key)   { return THEMES[key] || THEMES.dark; }
